import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { css, withStyles } from '../../assets/styles/withStyles';
import { getWork } from '../../redux/selectors/works';
import { getImageUrl, pad } from '../../utils';

class Project extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this._goToWork = this._goToWork.bind(this);
  }

  _goToWork() {
    const { work } = this.props;
    this.props.history.push('/work/' + work.category.slug + '/' + work.slug);
  }

  render() {
    const { styles, work } = this.props;

    if (!work) return null;

    return (
      <div
        onClick={this._goToWork}
        {...css(styles.container, work.full_size && styles.fullSize)}
      >
        <img
          alt={work.name}
          src={getImageUrl(work.image)}
          {...css(styles.image)}
        />
        <p {...css(styles.name)}>
          {work.num && <span {...css(styles.workNum)}>{pad(work.num, 3)}</span>}
          {work.name}
        </p>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  work: getWork(state, props.id)
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    withStyles(({ breakpoints }) => ({
      container: {
        width: '100%',
        float: 'right',
        cursor: 'pointer',

        [breakpoints.sm]: {
          width: '50%'
        }
      },
      image: {
        width: '100%'
      },
      fullSize: {
        width: '100% !important'
      },
      workNum: {
        paddingRight: 15
      },
      name: {
        fontSize: 14,
        lineHeight: '18px',
        paddingTop: 7,
        paddingBottom: 40,
        paddingLeft: 12,
        paddingRight: 12,

        [breakpoints.sm]: {
          fontSize: 17,
          lineHeight: '21px'
        }
      }
    }))(Project)
  )
);



// WEBPACK FOOTER //
// ./src/components/project/index.js